module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f61f.a114d57f.svg";